import { css } from 'styled-components';

const baseShadow = css`
  box-shadow:
    0 2px 2px 0 rgb(61 88 128 / 5%),
    0 4px 4px 2px rgb(61 88 128 / 5%),
    0 8px 8px 4px rgb(61 88 128 / 5%);
`;

const baseShadowLight = css`
  box-shadow: 0 2px 2px 0 rgb(61 88 128 / 5%);
`;

const baseShadowHover = css`
  box-shadow:
    0 2px 2px 0 rgb(61 88 128 / 10%),
    0 4px 4px 2px rgb(61 88 128 / 10%),
    0 8px 8px 4px rgb(61 88 128 / 10%);
`;

const shadowTuna = css`
  box-shadow: 0 5px 10px rgb(0 0 0 / 10%);
`;

// LEGACY SHADOWS - DO NOT USE
export const legacyShadows = {
  baseShadow,
  baseShadowLight,
  baseShadowHover,
  shadowTuna,
};
